import { Col, Row } from "reactstrap";

import AsyncSelectField from "@components/fields/react-select/async-select";
import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import SingleDatePicker from "@components/fields/date-picker/single-picker";
import { TASK_STATUS } from "../misc/constants";
import size from "lodash/size";
import useFilters from "@views/common/hooks/use-filter";
import useUpsert from "./use-upsert";

const UpsertTasks = (props) => {

    const {
        handleModalConfig,
        modalConfig: { isOpen, row }
    } = props;

    const isEdit = !!size(row);
    const { loadAsyncOptions } = useFilters();
    
    const { onSubmit, methods, updateLoading, isDirty } = useUpsert({
        ...props,
        isEdit
    });

    const {
        control,
        formState: { errors }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Task Information",
                desc : "Please provide the task information below."
            },
            rightChild: (
                <Row>
                    <Col lg={12}>
                        <InputField
                            errors={errors}
                            id="name"
                            label="Name"
                            name="name"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={12}>
                        <InputField
                            label="Description"
                            required
                            id="description"
                            name="description"
                            type="textarea"
                            control={control}
                            errors={errors}/>
                    </Col>
                    <Col lg={12}>
                        <Select
                            options={TASK_STATUS}
                            errors={errors}
                            label="Status"
                            name="status"
                            id="status"
                            control={control}
                            required/>
                    </Col>
                    
                    <Col lg={12}>
                        <AsyncSelectField
                            loadOptions={(value, callback) => {
                                loadAsyncOptions({
                                    value,
                                    callback,
                                    type       : "csm",
                                    context    : {},
                                    statusCheck: true
                                });
                            }}
                            defaultOptions
                            disabled={isEdit}
                            id="assignedTo"
                            required
                            isClearable
                            label="Assigned To"
                            name="assignedTo"
                            control={control}
                            errors={errors}/>
                    </Col>
                    <Col lg={12}>
                        <SingleDatePicker
                            label="Due Date"
                            id="dueDate"
                            name="dueDate"
                            required
                            format="yyyy-MM-dd"
                            errors={errors}
                            control={control}/>
                    </Col>
                </Row>
            )
        }
    ];

    return (
        <CommonModal
            title={`${isEdit ? "Update" : "Add"} Task`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="extraLarge"
            isDirty={isDirty}
            handleModal={handleModalConfig}
            isOpen={isOpen}/>
    );
};

export default UpsertTasks;